import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import Gallery from '../components/Gallery';
import ReviewCard from '../components/ReviewCard';

const HomePage: React.FC = () => {
  const services = [
    {
      title: 'Driveway Cleaning',
      description: 'Transform your driveway with our professional pressure washing services. Remove dirt, algae, and stains for a clean, renewed appearance.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/driveway-cleaning.png'
    },
    {
      title: 'Patio Washing',
      description: 'Restore your patio to its original beauty with our specialized cleaning process that removes moss, weeds, and years of built-up grime.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/patio-washing.png'
    },
    {
      title: 'Roof Cleaning',
      description: 'Extend the life of your roof and improve your property\'s appearance with our gentle but effective roof cleaning services.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/roof-cleaning-home.png'
    }
  ];

  const reviews = [
    {
      name: 'Jamie Lang',
      review: 'I would highly recommend Siscaro property solutions. Ronaldo was able to provide a reasonable quote to me quickly and efficiently after I messaged him initially. He then came out exactly when he said he would, worked tirelessly all day (and actually came back the next day to finish up as it started raining) and the result was incredible!'
    },
    {
      name: 'Kerri Bradshaw-Strauss',
      review: 'I cannot praise Ronaldo enough. Quote received when said, arrived when he said he would and the results on the work are absolutely phenomenal. We have had someone clean the drive way before which just removed some of the dirt, but this has basically been completely restored to look like a brand new driveway. 100% recommend Ronaldo and Siscaro Property Solutions. Super helpful, friendly and just an all round fantastic experience. Thank you!'
    },
    {
      name: 'Crb Adrian',
      review: 'Have had a fabulous transformation job completed on my patio and path by Siscaro Property Solution today. It\'s not just the quality of the finished job I\'m amazed at, it was the outstanding communication, both before and after the job. Such a positive vibe coming from this company, well done. Keep up the excellent work!'
    }
  ];

  return (
    <>
      <HeroSection />
      
      <section className="py-20 bg-black-light">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              Professional property cleaning services to keep your home looking its best
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <ServiceCard 
                key={index}
                title={service.title}
                description={service.description}
                image={service.image}
              />
            ))}
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-black">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title">Why Choose Us?</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              At Siscaro Property Solutions, we pride ourselves on delivering exceptional results and customer service
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div className="p-6">
              <div className="text-gold mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-gold font-bold text-xl mb-2">Professional Service</h3>
              <p className="text-white">Experienced professionals with extensive expertise</p>
            </div>
            
            <div className="p-6">
              <div className="text-gold mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-gold font-bold text-xl mb-2">Competitive Pricing</h3>
              <p className="text-white">Transparent pricing with no hidden fees or surprises</p>
            </div>
            
            <div className="p-6">
              <div className="text-gold mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-gold font-bold text-xl mb-2">Fast & Efficient</h3>
              <p className="text-white">Quick service with minimum disruption to your daily routine</p>
            </div>
            
            <div className="p-6">
              <div className="text-gold mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-gold font-bold text-xl mb-2">Customer Satisfaction</h3>
              <p className="text-white">Your satisfaction is our top priority - we're not happy until you are</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-black">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title">Our Work</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              Take a look at some of our recent transformations
            </p>
          </div>

          <div className="mb-16">
            <div className="max-w-2xl mx-auto">
              <div className="rounded-lg border-2 border-gold/30 transition-all duration-300 transform hover:scale-105">
                <video 
                  className="w-full rounded-lg"
                  controls
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                >
                  <source src="https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/videos/transformation-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <p className="text-white text-sm mt-4 text-center">Watch Our Latest Transformation Video</p>
            </div>
          </div>

          <Gallery />
        </div>
      </section>

      <section className="py-20 bg-black-light">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title">What Our Clients Say</h2>
            <p className="section-subtitle max-w-3xl mx-auto">
              See why our customers trust Siscaro Property Solutions
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <ReviewCard 
                key={index}
                name={review.name}
                review={review.review}
              />
            ))}
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-black-light">
        <div className="container-custom text-center">
          <h2 className="section-title">Ready to Transform Your Property?</h2>
          <p className="section-subtitle max-w-3xl mx-auto mb-8">
            Contact us today for a free quote and see how we can help restore your property to its former glory
          </p>
          <a href="/contact" className="btn-primary inline-block">
            Get a Quote
          </a>
        </div>
      </section>
    </>
  );
};

export default HomePage;